import styled from 'styled-components'

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  position: fixed;
  inset: 0;
  z-index: 999;
`
